<script setup lang="ts">
import { computed } from 'vue'

import { getParticipantTeamSide } from '@collector/shared-ui-domain'
import { Incident, Participant } from '@collector/sportsapi-client'
import PitchParticipantName from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchParticipantName.vue'

import ConfirmIncident from './ConfirmIncident.vue'

type Props = {
  reversed?: boolean
  participant: Participant
}

const props = defineProps<Props>()

// data
const maxVisibleIncidents = 2

// computed
const teamSide = computed(() => getParticipantTeamSide(props.participant))

// model
const incidents = defineModel<Incident[]>({ required: true })
</script>

<template>
  <div>
    <div
      class="relative"
      data-testid="incidents-to-confirm"
    >
      <div class="h-auto rounded-md p-1">
        <PitchParticipantName :participant />
        <!-- TODO: replace @sm with breakpoint for calculator-->
        <div
          v-if="!!incidents.length"
          class="-mr-1 h-20 space-y-2 overflow-x-hidden overflow-y-auto pt-2 pr-1 @sm:space-y-1"
        >
          <ConfirmIncident
            v-for="incident in [...incidents].reverse()"
            :key="incident.id"
            :class="{ 'flex-row-reverse': reversed }"
            :incident
            :teamSide
          />
        </div>
        <div
          v-else
          class="text-neutral-dark-7 flex h-20 flex-col items-center justify-center text-xs font-bold"
          data-testid="no-incidents-to-confirm-text"
        >
          <div>There are</div>
          <div>no incidents</div>
          <div>to confirm</div>
        </div>
      </div>
      <div
        v-if="incidents.length > maxVisibleIncidents"
        class="text-neutral-dark-3 bg-neutral-light-8 absolute bottom-0 w-full rounded-md text-center text-xs font-bold"
      >
        +{{ incidents.length - maxVisibleIncidents }} more
      </div>
    </div>
  </div>
</template>
